import react from "react";
import Request from "../../../../api/Requests";

const getUsersList = (params) => {
    
    return Request('admin/users-list', 'GET', params, true);
}

export default {
    getUsersList
}